import { Box, Stack, Typography } from '@mui/material';
import type { Currency } from '@weft/types';
import { Price } from 'apps/app/src/components/design/Price';

type HomePageInvoiceStatusPricingLineProps = {
  label: string;
  price: number;
  currency: Currency;
  color: string;
};

export const HomePageInvoiceStatusPricingLine: React.FC<HomePageInvoiceStatusPricingLineProps> = ({ color, label, price, currency }) => {
  return (
    <Stack
      gap={2}
      direction="row"
      alignItems="center"
      width="100%"
      paddingY={2}
    >
      <Box
        sx={{
          height: '12px',
          width: '12px',
          borderRadius: '100%',
          backgroundColor: color,
        }}
      />
      <Typography
        variant='body2'
        color={theme => theme.palette.text.secondary}
      >
        {label}
      </Typography>
      <Price
        sx={{
          marginLeft: 'auto',
        }}
        rounded
        currency={currency}
        variant='body2'
      >
        {price}
      </Price>
    </Stack>
  );
};